<template>
  <div class="tracking-item">
    <div class="tracking-item__image">
      <img :src="trackingItem.image_src" alt="product picture" />
      <div class="tracking-item__image-preview link" @click="previewImage">
        <ZoominIcon />
        Preview
      </div>
    </div>
    <div class="tracking-item__info">
      <div class="tracking-item__title">
        <sib-link
          v-if="trackingItem.handle"
          :to="trackingItem.handle"
          title=""
          >{{ trackingItem.title }}</sib-link
        >
      </div>
      <div class="tracking-item__options">{{ trackingItem.variant_title }}</div>
      <div class="tracking-item__properties">
        <div class="property__title">Quantity</div>
        <div class="property__value">{{ trackingItem.quantity }}</div>
        <template
          v-for="(property, i) in filterPropertyItem(trackingItem.properties)"
          :key="i"
        >
          <div class="property__title">{{ property.name }}</div>
          <div class="property__value">{{ property.value }}</div>
        </template>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { TrackingItem, Property } from '@/types/tracking'
import ZoominIcon from '@/assets/images/icons/zoom-in.svg'
import type { Fancybox as FancyboxType } from '@fancyapps/ui'

const props = withDefaults(
  defineProps<{
    trackingItem: TrackingItem
  }>(),
  {}
)

let Fancybox: FancyboxType | null = null

function filterPropertyItem(properties: Property[]) {
  if (!Array.isArray(properties)) return
  return properties.filter(
    (property: Property) => !property.name.startsWith('_')
  )
}

async function previewImage() {
  if (!props.trackingItem.image_src) return
  if (!Fancybox) {
    Fancybox = (await import('@fancyapps/ui')).Fancybox
  }

  Fancybox.show([
    {
      src: props.trackingItem.image_src,
      type: 'image',
    },
  ])
}
</script>

<style lang="scss">
.tracking-item {
  display: flex;
  align-items: flex-start;
  gap: 1em;
  padding: 1em 0;
  &__title {
    font-weight: normal;
  }
  &__image {
    --image-size: min(30%, 150px);
    min-width: var(--image-size);
    max-width: var(--image-size);
  }
  &__options,
  &__properties {
    margin: 0.5em 0;
    color: var(--text-color-tertiary);
    font-size: 0.875rem;
  }
  &__properties {
    display: grid;
    grid-template-columns: 1fr 1fr;
    @include media-sm-up {
      grid-template-columns: 200px 1fr;
    }
    gap: 0.5em 1em;
  }
  &__image-preview {
    font-size: 12px;
    font-weight: normal;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.3em;
    color: var(--color-primary);
    svg {
      width: 1em;
      height: 1em;
      path {
        stroke: var(--color-primary);
      }
    }
  }
}
</style>
